import { exportSidecar } from 'use-sidecar';
import 'react-focus-lock/sidecar';
import 'react-remove-scroll/sidecar';
import { Effect } from './Effect';
import { effectCar } from './medium';
export default exportSidecar(effectCar, Effect);



//////////////////
// WEBPACK FOOTER
// ./~/react-focus-on/dist/es2015/sidecar.js
// module id = 9005
// module chunks = 2